import EarthSectionBase from "./EarthSectionBase";
import comet from "../../images/assets/space/SPACE_COMET.svg"
import coin from "../../images/assets/shared/R_COIN.svg"
import floor from "../../images/assets/space/SPACE_FLOOR_01.svg"
import key from "../../images/assets/space/SPACE_KEY.svg"
import mountains from "../../images/assets/space/SPACE_MOUNTAINS.svg"
import planet from "../../images/assets/space/SPACE_PLANET_01.svg"
import sky from "../../images/assets/space/SPACE_SKY_01.svg"
import moon from "../../images/assets/space/SPACE_MOON.svg"
import {useTranslation} from "react-i18next";
import { useMemo } from "react";
import StarField from "../shared/StarField";
import CollectibleCoin, { getRandomCoinHover } from "../shared/CollectibleCoin";

export default function Space1({
   layer,
   collectedCoinIds = [],
   onCoinCollect
}){
    const { t } = useTranslation();

    const coinStyles = useMemo(
        () => [getRandomCoinHover(), getRandomCoinHover(), getRandomCoinHover()],
        []
    );

    const coins = [
        { id: "space1-coin-1", className: "space1-coin", style: coinStyles[0] },
        { id: "space1-coin-2", className: "space1-coin2", style: coinStyles[1] },
        { id: "space1-coin-3", className: "space1-coin3", style: coinStyles[2] },
    ]

    const goToNextSection = () => {
        const nextSection = document.getElementById("space2");
        nextSection?.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    }

    return (
        <EarthSectionBase
            id={layer.id}
            background={layer.bg}
            className={"earth-hero"}
        >
            <img src={sky} alt="" className={'background-img space1-sky'} />
            <img src={comet} alt="" className={'background-img space1-comet'} />
            <img src={planet} alt="" className={'background-img space1-planet'} />
            <img src={mountains} alt="" className={'background-img space1-mountains'} />
            <img src={floor} alt="" className={'background-img space1-floor tile'} />
            <img src={floor} alt="" className={'background-img space1-floor2 tile'} />
            <img src={moon} alt="" className={'background-img space1-moon'} />
            <img
                src={key}
                alt=""
                className={'background-img space1-key'}
                onClick={goToNextSection}
            />

            {coins.map((coinItem) => (
                <CollectibleCoin
                    key={coinItem.id}
                    id={coinItem.id}
                    src={coin}
                    className={`background-img coin ${coinItem.className} ${
                        collectedCoinIds.includes(coinItem.id) ? "coin-collected" : "coin-clickable"
                    }`}
                    style={coinItem.style}
                    isCollected={collectedCoinIds.includes(coinItem.id)}
                    onCollect={onCoinCollect}
                />
            ))}

            <StarField/>

            <div className="earth-hero-content">
                <div className="earth-hero-kicker">{t('greetings')}</div>
                <h1 className="earth-hero-title">{t('gameProgrammer')}</h1>
            </div>
        </EarthSectionBase>
    )
}